/**
 * Scope tier for an MCP OAuth connection. Mirrors `McpConnectionEntity.scope`
 * in `@novu/dal`. Only `subscriber` is implemented in v1; the remaining tiers
 * are reserved for future shared-token flows.
 */
export var McpConnectionScopeEnum;
(function (McpConnectionScopeEnum) {
    McpConnectionScopeEnum["Environment"] = "environment";
    McpConnectionScopeEnum["Agent"] = "agent";
    McpConnectionScopeEnum["Subscriber"] = "subscriber";
})(McpConnectionScopeEnum || (McpConnectionScopeEnum = {}));
/**
 * OAuth mechanism the connection was established with. Mirrors the catalog
 * `mode` for the MCP — each MCP supports exactly one mechanism.
 *
 * - `dcr`      — Dynamic Client Registration (RFC 7591). A fresh OAuth client
 *                is registered per subscriber against the upstream AS.
 * - `novu-app` — Novu's single pre-registered OAuth application is used.
 *                `client_id` / `client_secret` come from server env vars.
 * - `user-app` — The Novu customer's own pre-registered OAuth application is
 *                used. Credentials come from a per-org credential table.
 */
export var McpConnectionAuthModeEnum;
(function (McpConnectionAuthModeEnum) {
    McpConnectionAuthModeEnum["Dcr"] = "dcr";
    McpConnectionAuthModeEnum["NovuApp"] = "novu-app";
    McpConnectionAuthModeEnum["UserApp"] = "user-app";
})(McpConnectionAuthModeEnum || (McpConnectionAuthModeEnum = {}));
export var McpConnectionStatusEnum;
(function (McpConnectionStatusEnum) {
    McpConnectionStatusEnum["PendingOAuth"] = "pending_oauth";
    McpConnectionStatusEnum["Connected"] = "connected";
    McpConnectionStatusEnum["Expired"] = "expired";
    McpConnectionStatusEnum["Revoked"] = "revoked";
    McpConnectionStatusEnum["Error"] = "error";
})(McpConnectionStatusEnum || (McpConnectionStatusEnum = {}));
//# sourceMappingURL=managed-runtime.dto.js.map